import { CompanyDTOV1 } from '../swagger-api-v1';
import { License } from 'models/license';

export type PackageType = CompanyDTOV1.PackageTypeEnum;
export const PackageType = CompanyDTOV1.PackageTypeEnum;

export class Company {
  constructor(
    public id: number,
    public userId: number,
    public name: string,
    public username: string,
    public packageType: PackageType,
    public email: string,
    public externalId: string,
    public onnetLicenses: License,
    public mobileLicenses: License,
    public desktopLicenses: License,
    public mdmEnabled: boolean
  ) {}

  public static fromDTO(dto: CompanyDTOV1): Company {
    return new Company(
      dto.id,
      dto.userId,
      dto.name,
      dto.username,
      dto.packageType,
      dto.email,
      dto.externalId,
      License.fromDTO(dto.licenses.onnet),
      License.fromDTO(dto.licenses.mobile),
      License.fromDTO(dto.licenses.desktop),
      dto.mdmEnabled || false
    );
  }

  public toDTO(): CompanyDTOV1 {
    return {
      id: this.id,
      name: this.name,
      username: this.username,
      packageType: this.packageType,
      email: this.email,
      externalId: this.externalId,
      mdmEnabled: this.mdmEnabled
    } as CompanyDTOV1;
  }
}
